import Card from '../../components/Card';
import { useT } from '../../utils/useTranslation';
import heroBg from '../../assets/sas_hero_new.png';
import ajrakTexture from '../../assets/ajrak_texture_new.jpg';
import { motion } from 'framer-motion';
import HeroBackground from '../../components/ui/HeroBackground';
export default function QanoonPage() {
  const t = useT();
  const sections = [{
    title: t('article1Title'),
    content: t('article1Desc')
  }, {
    title: t('article2Title'),
    content: t('article2Desc')
  }, {
    title: t('article3Title'),
    content: t('article3Desc')
  }, {
    title: t('article4Title'),
    content: t('article4Desc')
  }, {
    title: t('article5Title'),
    content: t('article5Desc')
  }, {
    title: t('article6Title'),
    content: t('article6Desc')
  }, {
    title: t('article7Title'),
    content: t('article7Desc')
  }, {
    title: t('article8Title'),
    content: t('article8Desc')
  }];
  return <>
    <div className="hero-premium">
      <HeroBackground />
        <div style={{
          position: 'relative',
          zIndex: 10
        }}>
          <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} style={{
            fontFamily: 'var(--font-display)',
            fontSize: 48,
            fontWeight: 800,
            color: 'var(--sindhi-gold)',
            marginBottom: 16,
            letterSpacing: -1
          }}>
            {t('qanoon')}
          </motion.h1>
          <p style={{
            opacity: 0.8,
            fontSize: 18,
            maxWidth: 600,
            margin: '0 auto',
            fontWeight: 500
          }}>{t('qanoonSubtitle')}</p>
        </div>
      </div>

    <div style={{
      background: 'var(--sindhi-ivory)',
      backgroundImage: `url(${ajrakTexture})`,
      backgroundSize: '600px 600px',
      backgroundRepeat: 'repeat',
      position: 'relative',
      zIndex: 10
    }}>
      <div style={{
        position: 'absolute',
        inset: 0,
        backdropFilter: 'blur(3px)',
        WebkitBackdropFilter: 'blur(3px)',
        background: 'rgba(253,248,235,0.7)',
        zIndex: 0,
        pointerEvents: 'none'
      }} />
      <div style={{
        maxWidth: 900,
        margin: '0 auto',
        padding: '64px 24px 100px',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 20
        }}>
          {sections.map((s, i) => <Card key={i} style={{
            padding: 0,
            overflow: 'hidden',
            background: 'white'
          }}>
            <div style={{
              padding: '20px 28px',
              background: 'linear-gradient(90deg, var(--sindhi-navy), var(--sindhi-navy-mid))',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 16
            }}>
              <div style={{
                width: 32,
                height: 32,
                borderRadius: 10,
                background: 'var(--sindhi-maroon)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 14,
                fontWeight: 800,
                flexShrink: 0,
                boxShadow: '0 4px 10px rgba(0,0,0,0.2)'
              }}>{i + 1}</div>
              <h3 style={{
                fontFamily: 'var(--font-display)',
                fontSize: 17,
                fontWeight: 800
              }}>{s.title}</h3>
            </div>
            <div style={{
              padding: '24px 28px',
              color: 'var(--sindhi-text-muted)',
              lineHeight: 1.8,
              fontSize: 15
            }}>
              {s.content}
            </div>
          </Card>)}
        </div>

        <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} style={{
          marginTop: 48,
          padding: 32,
          background: 'var(--sindhi-maroon-glow)',
          border: '1px solid var(--sindhi-maroon)',
          borderRadius: 24,
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: 15,
            color: 'var(--sindhi-maroon)',
            fontWeight: 600
          }}>
            {t('qanoonSummary')}
          </p>
        </motion.div>
      </div>
    </div>
  </>;
}